import {PutFiveStars} from 'domain/usecases';
import {RemotePutFiveStars} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {FiveStarsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePutFiveStars = (): PutFiveStars =>
	new RemotePutFiveStars(
		makeBFFApiUrl(FiveStarsFlowEndPoints.fiveStarsFlow),
		makeAuthorizeHttpClientDecorator(),
	);
